import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InviteRoutingModule } from './invite-routing.module';
import { InviteComponent } from './invite.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, NgbModule, InviteRoutingModule],
  declarations: [InviteComponent]
})
export class InviteModule {}
